class CommutingView {

    constructor(onSelectOptionFn,
                onChangeDurationFn) {
        this.rootNode = $('.module--commuting');
        let options = {};
        this.rootNode.find('.commute-option').each(function(){
            let option = new CommutingOptionView($(this), onSelectOptionFn, onChangeDurationFn);
            options[option.commuteOptionName] = option;
        });
        this.options = options;
    }
}

class CommutingOptionView {
    constructor(rootNode,
                onSelectOptionFn,
                onChangeDurationFn) {
        this.rootNode = rootNode;

        this.commuteOptionName = this.rootNode.attr('data-commute-option');
        this.onSelectOptionFn = onSelectOptionFn;
        this.onChangeDurationFn = onChangeDurationFn;

        this.checkbox = this.rootNode.find('.form-check-input');
        this.duration = this.rootNode.find('.form-range');

        this.checkbox.change(this.onCheckboxChanged.bind(this));
        this.duration.change(this.onDurationChanged.bind(this));
    }

    onCheckboxChanged() {
        this.onSelectOptionFn(this.commuteOptionName, this.checkbox.isChecked());
    }

    onDurationChanged() {
        this.onChangeDurationFn(this.commuteOptionName, this.duration.val());
    }

    update(selected, duration) {
        this.checkbox.setChecked(selected);
        this.duration.val(duration);
        minutesRangeUpdated(this.duration);
    }
}
